import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Card, List, Typography } from 'antd'

import { req_single_gqm_graduateYearSurvey } from '../../api'

import { connect } from 'react-redux'


const { Text } = Typography;

class SurveyResponseModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////        
    static propTypes = {
        alumni: PropTypes.object.isRequired,
        yearSurvey: PropTypes.number.isRequired
    }

    state = {
        loading: false,
        item: {}
    }

    UNSAFE_componentWillMount() {
        this.init_values()
    }
    // 遠端數據處理 //////////////////////////////////////////////

    api_single_item = async () => {
        const { token } = this.props.user

        this.setState({ loading: true })
        const result = await req_single_gqm_graduateYearSurvey(this.props.yearSurvey, token)
        this.setState({ loading: false })
        this.setState({ item: result })
    }

    // 數據配置設定 //////////////////////////////////////////////    

    init_values = () => {
        this.api_single_item()
    }

    // 操作互動處理 //////////////////////////////////////////////   


    /////////////////////////////////////////////////////////////
    render() {
        console.log(this.state.item)
        const { YearSurvey, AlumniName, QuestionAA, AnswerAA, QuestionAB, AnswerAB, QuestionAC, AnswerAC, QuestionAD, AnswerAD, QuestionAE, AnswerAE, QuestionAF, AnswerAF, QuestionAG, AnswerAG, QuestionAH, AnswerAH, QuestionAI, AnswerAI, QuestionAJ, AnswerAJ, QuestionAK, AnswerAK, QuestionAL, AnswerAL, QuestionAM, AnswerAM, QuestionAN, AnswerAN } = this.state.item
        return (
            <Card title={AlumniName}>
                <List>
                    {YearSurvey === '1' ? (
                        <List.Item>
                            <Text strong><span>Q01.</span> {QuestionAA}</Text><br />
                            <Text strong><span>A01.</span> <span style={{ color: 'Blue' }}>{AnswerAA}</span></Text><br />
                            <Text strong><span>Q02.</span> {QuestionAB}</Text> <br />
                            <Text strong><span>A02.</span> <span style={{ color: 'Blue' }}>{AnswerAB}</span></Text><br />
                            <Text strong><span>Q03.</span> {QuestionAC}</Text> <br />
                            <Text strong><span>A03.</span> <span style={{ color: 'Blue' }}>{AnswerAC}</span></Text><br />
                            <Text strong><span>Q04.</span> {QuestionAD}</Text> <br />
                            <Text strong><span>A04.</span> <span style={{ color: 'Blue' }}>{AnswerAD}</span></Text><br />
                            <Text strong><span>Q05.</span> {QuestionAE}</Text> <br />
                            <Text strong><span>A05.</span> <span style={{ color: 'Blue' }}>{AnswerAE}</span></Text><br />
                            <Text strong><span>Q06.</span> {QuestionAF}</Text> <br />
                            <Text strong><span>A06.</span> <span style={{ color: 'Blue' }}>{AnswerAF}</span></Text><br />
                            <Text strong><span>Q07.</span> {QuestionAG}</Text> <br />
                            <Text strong><span>A07.</span> <span style={{ color: 'Blue' }}>{AnswerAG}</span></Text><br />
                            <Text strong><span>Q08.</span> {QuestionAH}</Text> <br />
                            <Text strong><span>A08.</span> <span style={{ color: 'Blue' }}>{AnswerAH}</span></Text><br />
                            <Text strong><span>Q09.</span> {QuestionAI}</Text> <br />
                            <Text strong><span>A09.</span> <span style={{ color: 'Blue' }}>{AnswerAI}</span></Text><br />
                            <Text strong><span>Q10.</span> {QuestionAJ}</Text> <br />
                            <Text strong><span>A10.</span> <span style={{ color: 'Blue' }}>{AnswerAJ}</span></Text><br />
                            <Text strong><span>Q11.</span> {QuestionAK}</Text> <br />
                            <Text strong><span>A11.</span> <span style={{ color: 'Blue' }}>{AnswerAK}</span></Text><br />
                            <Text strong><span>Q12.</span> {QuestionAL}</Text> <br />
                            <Text strong><span>A12.</span> <span style={{ color: 'Blue' }}>{AnswerAL}</span></Text><br />
                            <Text strong><span>Q13.</span> {QuestionAM}</Text> <br />
                            <Text strong><span>A13.</span> <span style={{ color: 'Blue' }}>{AnswerAM}</span></Text><br />
                        </List.Item>
                    ) : ''}
                    {YearSurvey === '3' ? (
                        <List.Item>
                            <Text strong><span>Q01.</span> {QuestionAA}</Text><br />
                            <Text strong><span>A01.</span> <span style={{ color: 'Blue' }}>{AnswerAA}</span></Text><br />
                            <Text strong><span>Q02.</span> {QuestionAB}</Text> <br />
                            <Text strong><span>A02.</span> <span style={{ color: 'Blue' }}>{AnswerAB}</span></Text><br />
                            <Text strong><span>Q03.</span> {QuestionAC}</Text> <br />
                            <Text strong><span>A03.</span> <span style={{ color: 'Blue' }}>{AnswerAC}</span></Text><br />
                            <Text strong><span>Q04.</span> {QuestionAD}</Text> <br />
                            <Text strong><span>A04.</span> <span style={{ color: 'Blue' }}>{AnswerAD}</span></Text><br />
                            <Text strong><span>Q05.</span> {QuestionAE}</Text> <br />
                            <Text strong><span>A05.</span> <span style={{ color: 'Blue' }}>{AnswerAE}</span></Text><br />
                            <Text strong><span>Q06.</span> {QuestionAF}</Text> <br />
                            <Text strong><span>A06.</span> <span style={{ color: 'Blue' }}>{AnswerAF}</span></Text><br />
                            <Text strong><span>Q07.</span> {QuestionAG}</Text> <br />
                            <Text strong><span>A07.</span> <span style={{ color: 'Blue' }}>{AnswerAG}</span></Text><br />
                            <Text strong><span>Q08.</span> {QuestionAH}</Text> <br />
                            <Text strong><span>A08.</span> <span style={{ color: 'Blue' }}>{AnswerAH}</span></Text><br />
                            <Text strong><span>Q09.</span> {QuestionAI}</Text> <br />
                            <Text strong><span>A09.</span> <span style={{ color: 'Blue' }}>{AnswerAI}</span></Text><br />
                            <Text strong><span>Q10.</span> {QuestionAJ}</Text> <br />
                            <Text strong><span>A10.</span> <span style={{ color: 'Blue' }}>{AnswerAJ}</span></Text><br />
                            <Text strong><span>Q11.</span> {QuestionAK}</Text> <br />
                            <Text strong><span>A11.</span> <span style={{ color: 'Blue' }}>{AnswerAK}</span></Text><br />
                            <Text strong><span>Q12.</span> {QuestionAL}</Text> <br />
                            <Text strong><span>A12.</span> <span style={{ color: 'Blue' }}>{AnswerAL}</span></Text><br />
                            <Text strong><span>Q14.</span> {QuestionAM}</Text> <br />
                            <Text strong><span>A14.</span> <span style={{ color: 'Blue' }}>{AnswerAM}</span></Text><br />
                            <Text strong><span>Q14.</span> {QuestionAN}</Text> <br />
                            <Text strong><span>A14.</span> <span style={{ color: 'Blue' }}>{AnswerAN}</span></Text><br />
                        </List.Item>
                    ) : ''}
                    {YearSurvey === '5' ? (
                        <List.Item>
                            <Text strong><span>Q01.</span> {QuestionAA}</Text><br />
                            <Text strong><span>A01.</span> <span style={{ color: 'Blue' }}>{AnswerAA}</span></Text><br />
                            <Text strong><span>Q02.</span> {QuestionAB}</Text> <br />
                            <Text strong><span>A02.</span> <span style={{ color: 'Blue' }}>{AnswerAB}</span></Text><br />
                            <Text strong><span>Q03.</span> {QuestionAC}</Text> <br />
                            <Text strong><span>A03.</span> <span style={{ color: 'Blue' }}>{AnswerAC}</span></Text><br />
                            <Text strong><span>Q04.</span> {QuestionAD}</Text> <br />
                            <Text strong><span>A04.</span> <span style={{ color: 'Blue' }}>{AnswerAD}</span></Text><br />
                            <Text strong><span>Q05.</span> {QuestionAF}</Text> <br />
                            <Text strong><span>A05.</span> <span style={{ color: 'Blue' }}>{AnswerAF}</span></Text><br />
                            <Text strong><span>Q06.</span> {QuestionAG}</Text> <br />
                            <Text strong><span>A06.</span> <span style={{ color: 'Blue' }}>{AnswerAG}</span></Text><br />
                            <Text strong><span>Q07.</span> {QuestionAH}</Text> <br />
                            <Text strong><span>A07.</span> <span style={{ color: 'Blue' }}>{AnswerAH}</span></Text><br />
                            <Text strong><span>Q08.</span> {QuestionAI}</Text> <br />
                            <Text strong><span>A08.</span> <span style={{ color: 'Blue' }}>{AnswerAI}</span></Text><br />
                            <Text strong><span>Q09.</span> {QuestionAJ}</Text> <br />
                            <Text strong><span>A09.</span> <span style={{ color: 'Blue' }}>{AnswerAJ}</span></Text><br />
                            <Text strong><span>Q10.</span> {QuestionAK}</Text> <br />
                            <Text strong><span>A10.</span> <span style={{ color: 'Blue' }}>{AnswerAK}</span></Text><br />
                            <Text strong><span>Q11.</span> {QuestionAL}</Text> <br />
                            <Text strong><span>A11.</span> <span style={{ color: 'Blue' }}>{AnswerAL}</span></Text><br />
                            <Text strong><span>Q12.</span> {QuestionAM}</Text> <br />
                            <Text strong><span>A12.</span> <span style={{ color: 'Blue' }}>{AnswerAM}</span></Text><br />
                        </List.Item>
                    ) : ''}
                </List>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(SurveyResponseModal)